import { googlePlacesApi } from "./api"

export const getAddressSugestions = async text => {
  if (!text) return
  const resp = await googlePlacesApi.post('places:autocomplete', {
    input: text,
    includedRegionCodes: ['pe'],
  },
  {
    headers: {
      'X-Goog-FieldMask': 'suggestions.placePrediction.text.text,suggestions.placePrediction.placeId'
    }
  })
  const refinedData = resp.data.suggestions.map(suggestion => {
    return {
      id: suggestion.placePrediction.placeId,
      text: suggestion.placePrediction.text.text
    }
  })
  return refinedData
}
export const getPlaceInfoWithId = async id => {
  try {
    const resp = await googlePlacesApi.get(`places/${id}`, {
      headers: {
        'X-Goog-FieldMask': 'id,addressComponents,location,googleMapsUri,displayName,shortFormattedAddress,postalAddress'
      }
    })
    const place = resp.data
    const parsedComponents = parseAddressComponents(place.addressComponents)

    return {
      fullAddress: place.shortFormattedAddress,
      place_id: place.id,
      coordinates: {
        lat: place.location.latitude,
        lng: place.location.longitude,
      },
      street: parsedComponents.street.trim(),
      city: parsedComponents.city,
      state: parsedComponents.state,
      country: parsedComponents.country,
      postalCode: parsedComponents.postalCode
    }
  } catch (e) {
    console.log(e)
  }
}

export const getAddressFromCoordinates = async (lat, lng) => {
  try {
    // Verificar que Google Maps esté disponible
    if (!window.google || !window.google.maps) {
      throw new Error('Google Maps API not loaded')
    }

    const geocoder = new google.maps.Geocoder()

    const response = await new Promise((resolve, reject) => {
      geocoder.geocode(
        { location: { lat, lng } },
        (results, status) => {
          if (status === 'OK') {
            resolve(results)
          } else {
            reject(new Error(`Geocoding failed: ${status}`))
          }
        }
      )
    })

    if (response && response.length > 0) {
      const result = response[0]
      const parsedComponents = parseAddressComponents(result.address_components)
      return {
        place_id: result.place_id,
        fullAddress: result.formatted_address,
        coordinates: { lat, lng },
        street: parsedComponents.street.trim(),
        city: parsedComponents.city,
        state: parsedComponents.state,
        district: parsedComponents.district,
        country: parsedComponents.country,
        postalCode: parsedComponents.postalCode
      }
    }
    return null
  } catch (error) {
    console.error('Error getting address:', error)
    throw error
  }
}

const parseAddressComponents = addressComponents => {
  const result = {
    street: '',
    city: '',
    state: '',
    country: '',
    postalCode: ''
  }

  addressComponents.forEach(component => {
    const types = component.types
    const longText = component.longText || component.long_name
    const shortText = component.shortText || component.short_name

    if (types.includes('street_number')) result.street = longText + ' ' + result.street
    if (types.includes('route')) result.street = result.street + longText
    if (types.includes('locality')) result.city = longText
    if (types.includes('administrative_area_level_2')) result.district = longText
    if (types.includes('administrative_area_level_1')) result.state = longText
    if (types.includes('country')) result.country = longText
    if (types.includes('postal_code')) result.postalCode = longText
  })

  return result
}
